module.exports = (__webpack_require__(0))(119);


//////////////////
// WEBPACK FOOTER
// delegated ./src/collections/FolderCollection.js from dll-reference girder_lib
// module id = 145
// module chunks = 0